const host = window.location.hostname;

const configs = {
    localhost: {
        owner: 'QuiteJá',
        ownerUrl: 'https://quiteja.com.br',
        pageTitle: 'Dodo',
        socketRasaUrl: 'http://localhost:5010',
        socketOptions: '',
        logo: 'https://www.vexels.com/png-svg/preview/153290/processor-colored-stroke-icon',
        externalRefUrl: 'http://localhost:8283/#!/customer/',
        authUrl: 'http://localhost:5805/oauth/login',
        appsUrl: 'http://localhost:9292',
        rasaApi: 'http://localhost:5805/v1',
        backofficeUrl: 'http://localhost:8283/#!',
        hermesUrl: 'http://localhost:8285',
        externalRefHermesUrl: 'http://localhost:8283/#!/customer/',
        name: 'development',
        cookiesDomain: 'localhost'
    },
    'dodo.staging.gorillascode.com': {
        owner: 'QuiteJá',
        ownerUrl: 'https://quiteja.com.br',
        pageTitle: 'Dodo - STAGING',
        socketRasaUrl: 'https://socketio.rasa.staging.gorillascode.com',
        socketOptions: '/socket.io',
        logo: 'https://www.vexels.com/png-svg/preview/153290/processor-colored-stroke-icon',
        authUrl: 'https://api.rasa.staging.gorillascode.com/oauth/login',
        externalRefUrl: 'https://backoffice.quiteja.staging.gorillascode.com/customer/',
        externalRefHermesUrl: 'https://hermes.quiteja.com.br/customer/',
        appsUrl: 'https://auth.staging.gorillascode.com',
        rasaApi: 'https://api.rasa.staging.gorillascode.com/v1',
        backofficeUrl: 'https://backoffice.quiteja.staging.gorillascode.com',
        hermesUrl: 'https://hermes.quiteja.staging.gorillascode.com',
        name: 'staging',
        cookiesDomain: '.dodo.staging.gorillascode.com'
    },
    'dodo.gorillascode.com': {
        owner: 'QuiteJá',
        ownerUrl: 'https://quiteja.com.br',
        pageTitle: 'Dodo',
        socketRasaUrl: 'https://socketio.rasa.quiteja.com.br',
        socketOptions: '/socket.io',
        logo: 'https://www.vexels.com/png-svg/preview/153290/processor-colored-stroke-icon',
        authUrl: 'https://api.rasa.quiteja.com.br/oauth/login',
        externalRefUrl: 'https://backoffice.quiteja.com.br/customer/',
        externalRefHermesUrl: 'https://hermes.quiteja.com.br/customer/',
        appsUrl: 'https://auth.quiteja.com.br',
        rasaApi: 'https://rasa.quiteja.com.br/api/v1',
        backofficeUrl: 'https://backoffice.quiteja.com.br',
        hermesUrl: 'https://hermes.quiteja.com.br',
        name: 'production',
        cookiesDomain: '.dodo.gorillascode.com'
    }
};

let env = {};
if (host.includes('pr-')) {
    env = {
        owner: 'QuiteJá',
        ownerUrl: 'https://quiteja.com.br',
        pageTitle: 'Dodo - PR',
        socketRasaUrl: 'https://socketio.rasa.staging.gorillascode.com',
        socketOptions: '/socket.io',
        logo: 'https://www.vexels.com/png-svg/preview/153290/processor-colored-stroke-icon',
        authUrl: 'https://api.rasa.staging.gorillascode.com/oauth/login',
        externalRefUrl: 'https://backoffice.quiteja.staging.gorillascode.com/customer/',
        externalRefHermesUrl: 'https://hermes.quiteja.com.br/customer/',
        appsUrl: 'https://auth.staging.gorillascode.com',
        rasaApi: 'https://api.rasa.staging.gorillascode.com/v1',
        backofficeUrl: 'https://backoffice.quiteja.staging.gorillascode.com',
        hermesUrl: 'https://hermes.quiteja.staging.gorillascode.com',
        name: 'staging',
        cookiesDomain: '.dodo.staging.gorillascode.com'
    };
} else {
    env = {
        /** Todas as configurações de todos os ambientes. */
        configs: configs,

        /** Metadados globais */
        owner: configs[host].owner,
        ownerUrl: configs[host].ownerUrl,
        pageTitle: configs[host].pageTitle,
        logo: configs[host].logo,

        /** Conexão com Rasa */
        socketRasaUrl: configs[host].socketRasaUrl,
        socketOptions: configs[host].socketOptions,
        rasaApi: configs[host].rasaApi,

        /** URLs de autenticação e apps */
        authUrl: configs[host].authUrl,
        appsUrl: configs[host].appsUrl,

        /** URLs externas */
        externalRefUrl: configs[host].externalRefUrl,
        externalRefHermesUrl: configs[host].externalRefHermesUrl,
        backofficeUrl: configs[host].backofficeUrl,
        hermesUrl: configs[host].hermesUrl,

        /** Metadados de ambiente */
        name: configs[host].name,
        cookiesDomain: configs[host].cookiesDomain,
    };
}

export default env;
